import { forwardRef } from 'react'
import type { CheckboxFormatterProps } from 'react-data-grid'

const CheckboxFormatter = forwardRef<HTMLInputElement, CheckboxFormatterProps>(
  function CheckboxFormatter({ disabled, onChange, ...props }, ref) {
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      onChange(e.target.checked, (e.nativeEvent as MouseEvent).shiftKey);
    }

    return <input type="checkbox"
      className='w-full h-full'
      disabled={disabled}
      ref={ref} {...props} 
      onChange={handleChange} 
    />;
  }
);

export default CheckboxFormatter